import React, { Component } from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import { Route } from 'react-router-dom';

import List from './List';
import NewPost from './NewPost';
import EditPost from './EditPost';
import { PostTagsQuery } from './queries';

class Container extends Component {
  render() {
    const { ModelTags } = this.props.data;

    return (
      <div id="posts">
        <Route exact path="/posts" component={List} />
        <Route exact path="/posts/new" render={(props) => <NewPost modelTags={ModelTags} {...props} /> }/>
        <Route exact path="/posts/:id/edit" render={(props) => <EditPost modelTags={ModelTags} {...props} /> }/>
      </div>
    );
  }
}

export default compose(
  graphql(PostTagsQuery),
  withApollo,
)(Container);